import { createForm } from '../../../factories'

export default createForm(['mediaIDs'])



// WEBPACK FOOTER //
// ./src/store/modules/modules/forms/relateMedia.js